import { NgModule } from '@angular/core';
import {SafeUrlPipe} from 'ng2-app/pipes/url/safe-url.pipe';

@NgModule({
  imports: [],
  exports: [SafeUrlPipe],
  declarations: [SafeUrlPipe],
  providers: [],
})
export class SafeUrlPipeModule { }
